<script lang="ts">
	import type { SvelteAsr } from 'types/common'
	import type { InterchangeRecord } from 'utility/interchange-lookup'

	import Interchange from 'components/Interchange.svelte'
	import { onMount } from 'svelte'

	interface Props {
		asr: SvelteAsr
		inventoryTypeId?: number
		year?: number
		manufacturer?: string
		model?: string
		interchangeNumber?: string
		subInterchangeNumber?: string
		lastSearchType?: 'VEHICLE_INFO' | 'INTERCHANGE_NUMBER'
	}

	let {
		asr,
		inventoryTypeId,
		year,
		manufacturer,
		model,
		interchangeNumber,
		subInterchangeNumber,
		lastSearchType,
	}: Props = $props()

	let interchangeList: Array<InterchangeRecord> = $state([])
	let interchangeComponent: Interchange | undefined = $state()

	async function interchangeClick({ interchange }: { interchange: InterchangeRecord }) {
		interchangeNumber = interchange.interchangeNumber
		subInterchangeNumber = interchange.subInterchangeNumber
		asr.go(null, {
			inventoryTypeId,
			manufacturer: manufacturer || undefined,
			model: model || undefined,
			year: year || undefined,
			interchangeNumber: interchangeNumber || undefined,
			subInterchangeNumber: subInterchangeNumber || undefined,
		})
	}

	// TODO call this function from a button on the interchange rows once we have interchange # searching on the search screen
	function inventorySearch(interchangeRecord: { inventoryTypeId: number; interchangeNumber: string }) {
		//TODO fix this ASR parameter value
		//asr.go('app.part-search.results', { inventoryTypeId, interchangeNumber })
	}

	onMount(async () => {
		if (!inventoryTypeId) {
			return
		}

		if (lastSearchType === 'INTERCHANGE_NUMBER') {
			await interchangeComponent?.search({
				inventoryTypeId,
				interchangeNumber,
				subInterchangeNumber,
			})
		} else if (lastSearchType === 'VEHICLE_INFO') {
			await interchangeComponent?.search({
				inventoryTypeId,
				vehicleYear: year,
				make: manufacturer,
				model: model,
			})
		}
	})
</script>

<Interchange
	{asr}
	{interchangeClick}
	{inventorySearch}
	bind:interchangeList
	bind:this={interchangeComponent}
/>
